import React from 'react';
import { Global, css } from '@emotion/core';
const BaseStyles = ({ fontCDNPath, }) => (React.createElement(Global, { styles: css `
        @font-face {
            font-family: "Inter";
            src: url("${fontCDNPath}/Inter-Regular.woff2") format("woff2"), url('${fontCDNPath}/Inter-Regular.woff') format('woff');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: "Inter";
            src: url("${fontCDNPath}/Inter-Medium.woff2") format("woff2"), url('${fontCDNPath}/Inter-Medium.woff') format('woff');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: "Inter";
            src: url("${fontCDNPath}/Inter-SemiBold.woff2") format("woff2"), url('${fontCDNPath}/Inter-SemiBold.woff') format('woff');
            font-weight: 600;
            font-style: normal;
            font-display:  sswap;
        }
    ` }));
export default BaseStyles;
